import { Illustrations } from "@/illustrations";
import { ConnectorType } from "@pufflig/prompt-studio-types";
import { ReactElement } from "react";

interface IntegrationInfo {
  title: string;
  logo: ReactElement;
  isAvailable: boolean;
}

export const integrationData: Record<ConnectorType, IntegrationInfo> = {
  postgres: {
    title: "PostgreSQL",
    logo: <Illustrations.Postgres />,
    isAvailable: true,
  },
  snowflake: {
    title: "Snowflake",
    logo: <Illustrations.Snowflake />,
    isAvailable: true,
  },
  ms_fabric_sql: {
    title: "Microsoft Fabric - SQL Endpoint",
    logo: <Illustrations.MicrosoftFabric />,
    isAvailable: true,
  },
  bigquery: {
    title: "BigQuery",
    logo: <div style={{ width: "3rem", height: "3rem", background: "#eee" }} />,
    isAvailable: false,
  },
};
